'use client';
import React, { useEffect, useState } from "react";
import blogApi from "../../../../services/blogApi";
import "./CommentsSection.css";
import { getRelativeTimeString } from "../../../../Utils/datetime";
import DOMPurify from "isomorphic-dompurify";

const CommentsSection = ({ postId }) => {
    const [comments, setComments] = useState([]);

    useEffect(() => {
        const fetchComments = async () => {
            const response = await blogApi.getComments(postId);
            setComments(response?.data || []);
        };

        if (postId) {
            fetchComments();
        }
    }, [postId]);

    if (!comments || comments.length === 0) {
        return <div className="comments-title"></div>;
    }

    return (
        <div className="comments-section">
            <h3 id="comments-title">{comments.length} Comments</h3>

            {comments.map((comment) => {
                const safeHTML = DOMPurify.sanitize(
                    comment?.content?.rendered || ""
                );

                return (
                    <div key={comment.id} className="comment-box">
                        <p className="comment-author">{comment.author_name}</p>
                        <p className="comment-date">
                            {getRelativeTimeString(comment.date)}
                        </p>

                        <div
                            className="comment-text"
                            dangerouslySetInnerHTML={{ __html: safeHTML }}
                        />
                    </div>
                );
            })}
        </div>
    );
};

export default CommentsSection;
